import { integer, text } from 'drizzle-orm/sqlite-core';
import { v4 } from 'uuid';

// Shared columns for all tables: id, source, createdAt, updatedAt
export const baseColumns = {
  id: text('id')
    .primaryKey()
    .$defaultFn(() => v4()),
  source: text('source').notNull(), // 'client' | 'mobile'
  createdAt: integer('created_at')
    .notNull()
    .$defaultFn(() => Date.now()),
  updatedAt: integer('updated_at')
    .notNull()
    .$defaultFn(() => Date.now())
    .$onUpdateFn(() => Date.now())
};

// Shared columns for snapshot tables: id, createdAt (no source or updatedAt — snapshots are immutable)
export const snapshotBaseColumns = {
  id: text('id')
    .primaryKey()
    .$defaultFn(() => v4()),
  createdAt: integer('created_at')
    .notNull()
    .$defaultFn(() => Date.now())
};
